import { uniqueCallbackQueue } from '../_helpers/uniqueCallbackQueue'
import { getPageType } from '../_helpers/getPageType'

const uniqueQueue = uniqueCallbackQueue()

// these are the original events we emitted from the first release of nuxt, some if these should be replaced by the Advanced Equiv
export function wireClassicEvents(app) {
    app.$uiEvents.$on('errorPageViewed', emitErrorPageViewed)
    app.$uiEvents.$on('noResultsViewed', emitNoResults)
    app.$uiEvents.$on('expressShippingViewed', emitExpressShippingViewed)
    app.$uiEvents.$on('doesNotFitViewed', emitDoesNotFitViewed)
}

function emitExpressShippingViewed(fullPath) {
    uniqueQueue(emitGeneralGTMEvent, ['express shipping - viewed', 'product-line', fullPath])

    // for future google optimize fun :)
    window.dataLayer.push({ event: 'optimize.activate.expressShipping' })
}
function emitNoResults(route) {
    emitGeneralGTMEvent('no results', getPageType(route.name), route.fullPath)
}

function emitDoesNotFitViewed(fullPath) {
    emitGeneralGTMEvent('does not fit', 'product-line', fullPath)
}

function emitErrorPageViewed(fullPath, statusCode) {
    emitGeneralGTMEvent(statusCode, 'error page', fullPath)
}

function emitGeneralGTMEvent(action, category, label, value) {
    window.dataLayer.push({
        event: 'custom.event.general',
        'custom.gtm.eventData': {
            action,
            category,
            label,
            value,
        },
    })
}
